import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { result } from 'lodash-es';
import { Message } from 'src/app/communication/shared';
import { CommunicationService } from 'src/app/communication/shared/communication.service';
import { MessageProfileIdSearchOptionEnum } from 'src/app/communication/shared/message-profile-Id-search-option.enum';
import { MessageProfileIdSearchDto } from 'src/app/communication/shared/message-profile-id-search.dto';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { ConfigService } from 'src/app/config/shared/config.service';
import { ProfileSearchComponentModel } from 'src/app/profiles/search/profile-search-component.model';
import { ProfileSearchParameterService } from 'src/app/profiles/shared/profile-search-parameter.service';
import { ProfileSearchV2ParameterService } from 'src/app/profiles/shared/profile-search-v2-parameter.service';
import { NotificationService } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'wl-mass-comm-profile-selector-dialog',
  templateUrl: './mass-comm-profile-selector-dialog.component.html',
  providers: [ProfileSearchParameterService],
  styleUrl: './mass-comm-profile-selector-dialog.component.less',
    standalone: false
})
export class MassCommProfileSelectorDialogComponent implements OnInit {
  @Input() public message: Message = null;

  show: boolean = false;
  isLoading: boolean = false;
  selectedOption: MessageProfileIdSearchOptionEnum;
  messageProfileIdSearchOptionEnum = MessageProfileIdSearchOptionEnum;
  searchDto = {} as MessageProfileIdSearchDto;
  useV2ProfileSelector: boolean = false;
  constructor(
    private _communicationService: CommunicationService,
    private _navigationService: NavigationService,
    private _profileSearchParameterService: ProfileSearchParameterService,
    private _profileSearchV2ParameterService: ProfileSearchV2ParameterService,
    private _userService: UserService,
    private _configService: ConfigServiceService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this._userService.getCurrentUser().then((user) => {
      // Check whether to set V2 or original search Results
      this._configService.checkForProfileSearchConfig(user.UserNum.toString()).then((hasProfileSelectorConfig) => {
        this.useV2ProfileSelector = hasProfileSelectorConfig;
      });
    });
  }

  public open() {
    this.show = true;
  }

  public close() {
    this.show = false;
  }

  public openInProfileSelector() {
    this.searchDto.MessageId = this.message.MessageId;
    this._communicationService
      .getMessageProfileIds(this.searchDto)
      .then((result) => {
        const profileids = result;
        const profileSearchModel = new ProfileSearchComponentModel();
        if (profileids && profileids.length) {
          profileSearchModel.searchParams.PermitProfiles = profileids;
          this._profileSearchV2ParameterService.setSearchLoadOptions({ RunOnLoad: true, HideAdvancedParams: true, FromNavigation: true });
          if (this.useV2ProfileSelector) {
            // Having both V2 and original results stored locally will mess up opening the V2 Profile Selector so clear it out.
            this._profileSearchParameterService.clearProfileSearchResults();
            this._profileSearchV2ParameterService.setProfileSearchResults(profileSearchModel);
          } else {
            this._profileSearchParameterService.setProfileSearchResults(profileSearchModel);
          }
          this._navigationService.navigateToProfileFinder();
        } else {
          this._notificationService.translateError('reports.saved-queries.no-results');
        }
      })
      .catch((err: HttpErrorResponse) => {
        this._notificationService.httpError(err);
      });
  }
}
